module.exports = __webpack_public_path__ + "static/media/launch_beach_1.1bff79f8.svg";